import { createSlice } from '@reduxjs/toolkit';
import {
  FetchReleaseNotesAction,
  ReleaseNotesInterface,
  ReleaseNotesReceivedAction
} from '../actions/ReleaseNotes';

const initialState: ReleaseNotesInterface = {
  releaseNotes: null,
  isFetchingReleaseNotes: false
};

const ReleaseNotes = createSlice({
  name: 'ReleaseNotes',
  initialState,
  reducers: {
    getReleaseNotes: (state, _action: FetchReleaseNotesAction) => {
      state.isFetchingReleaseNotes = true;
    },

    releaseNotesReceived: (state, action: ReleaseNotesReceivedAction) => {
      state.isFetchingReleaseNotes = false;
      state.releaseNotes = action.payload.releaseNotes;
    }
  }
});

export const { getReleaseNotes, releaseNotesReceived } = ReleaseNotes.actions;
export default ReleaseNotes.reducer;
